import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import filterFactory from "react-bootstrap-table2-filter";
import { postSubmitForm } from "../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../helpers/show_notification";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
  mapUnits,
} from "../../helpers/units";
import preloader from "../../helpers/preloader";
import paginationFactory from "react-bootstrap-table2-paginator";
import Breadcrumb_2Items from "../../components/Common/Breadcrumb_2Items";
import BatchWithdrawlCorrection from "../../components/BatchWithdrawlCorrection";

const ItemWithdrawlCorrection = (props) => {
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [selectedRow, setSelectedRow] = useState([]);
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    loadAllStores();
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setAllItems([]);
    }
  }, [dateFrom, dateTo]);

  const [selectedStore, setSelectedStore] = useState("");
  const [allstores, setAllStore] = useState([]);
  const loadAllStores = async () => {
    try {
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "stores/getall";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        const stores = response.data || [];
        setAllStore(stores);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const [allItems, setAllItems] = useState([]);
  const loadMappedItems = async () => {
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 31) {
        setAllItems([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setAllItems([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      preloader(true);
      setAllItems([]);
      const url =
        process.env.REACT_APP_BASEURL + "corrections/get_item_withdrawals";
      // Single API call
      const response = await postSubmitForm(url, {
        date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
        date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
        store_id: selectedStore,
      });

      if (response && response.status === 1) {
        setAllItems(response.data);
      } else {
        showNotification(response.message || "Error", "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const [transactionsModal, setTransactionsModal] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [selectedItem_Transactions, setSelectedItem_Transactions] = useState(
    [],
  );
  const handleViewDetailsClick = async (row) => {
    try {
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "corrections/get_by_item_id";
      const response = await postSubmitForm(url, {
        store_id: selectedStore,
        item_id: row.item_id,
      });
      if (response && response.status === 1) {
        setSelectedItem_Transactions(response.data);
        setSelectedItem(row);
        setTransactionsModal(!transactionsModal);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };
  function viewFormatter(cell, row) {
    return (
      <span className="text-info">
        <i
          className="mdi mdi-text-box-search font-size-15"
          title="View Details"
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleViewDetailsClick(row);
          }}
        ></i>
      </span>
    );
  }

  const [editModal, setEditModal] = useState(false);
  function editFormatter(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(row.quantity && row.quantity)}
          </span>
          {selectedRow && (
            <Button
              className="btn btn-success btn-sm"
              onClick={() => {
                let updatedItem = {
                  ...row,
                  unit_levels: row.item_details.unit_levels,
                  name: row.item_details.name,
                  quantity: row.quantity?.map((item, idx) => ({
                    ...item,
                    index: idx,
                    isChecked: true,
                  })),
                };
                setSelectedItem(updatedItem);
                setSelectedRow(updatedItem);
                setEditModal(true);
              }}
            >
              <i class="mdi mdi-edit"></i>
              {props.t("Edit")}
            </Button>
          )}
        </div>
      </>
    );
  }

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "total",
      text: "Total Used ",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.total);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Action"),
      formatter: viewFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
  ];

  const columns_transaction = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Used Quantity"),
      formatter: editFormatter,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "batch_inventory",
      text: props.t("Batch Avail."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.batch_inventory);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "selling_price",
      text: props.t("Selling Price"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Expiry Date"),
      sort: false,
      formatter: (cell, row) => {
        return row.expiry_date
          ? moment(row.expiry_date).format("DD/MM/YYYY HH:mm")
          : " ";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "",
      text: props.t("Used Date"),
      sort: false,
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
      },
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const pagination_options = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "All",
        value: selectedItem_Transactions && selectedItem_Transactions.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (quantity) => {
    // Validate input
    if (!selectedRow || !selectedItem) {
      showNotification("No item selected", "error");
      return;
    }

    // Find the specific item in delivery_details
    const deliveryItem = selectedItem_Transactions.find(
      (item) => item._id === selectedRow._id,
    );

    if (!deliveryItem) {
      showNotification("Item not found", "error");
      return;
    }
    // Convert quantities to the lowest unit for
    const batch_Inv = convertToLowestUnit(
      deliveryItem.item_details?.unit_levels,
      deliveryItem?.batch_inventory,
    );

    const used_Qty = convertToLowestUnit(
      deliveryItem.item_details?.unit_levels,
      deliveryItem?.quantity,
    );
    const updated_Qty = convertToLowestUnit(
      deliveryItem.item_details?.unit_levels,
      quantity,
    );
    const lastUnitObj = deliveryItem.item_details?.unit_levels.at(-1).unit;

    // Early return if no change in quantity
    if (updated_Qty === used_Qty) {
      showNotification("Quantity unchanged", "info");
      return;
    }

    try {
      let updatedDeliveryDetails;
      let remainingQuantity;
      let url =
        process.env.REACT_APP_BASEURL + "corrections/item_withdraw_correction";
      setIsLoading(true);
      // CASE 1: Updated Qty is greater than used quantity
      if (updated_Qty > used_Qty) {
        remainingQuantity = Number(updated_Qty) - Number(used_Qty);

        if (remainingQuantity > batch_Inv) {
          showNotification("Not enough inventory in batch", "Warning");
          return;
        }

        const convertedQuantity = GetUpdatedDelivered(
          quantity,
          deliveryItem.item_details?.unit_levels,
        );
        const newInventoryQuantity = [
          {
            unit: lastUnitObj,
            value: Number(batch_Inv) - Number(remainingQuantity),
          },
        ];

        const correctionQuantity = [
          { unit: lastUnitObj, value: Number(remainingQuantity) },
        ];
        const correctionQuantityToBeAdded = GetUpdatedDelivered(
          correctionQuantity,
          deliveryItem.item_details?.unit_levels,
        );

        let payload = {
          item_id: deliveryItem.item_details._id,
          store_id: selectedStore,
          batch_id: selectedItem._id,
          batch: selectedItem.batch,
          before_correction_quantity: selectedItem.quantity,
          type: "Debit",
          correction_quantity: correctionQuantityToBeAdded.map(
            ({ unit, value }) => ({ unit, value: +value }),
          ),
          quantity: convertedQuantity.map(({ unit, value }) => ({
            unit,
            value: +value,
          })),
          batch_inventory: GetUpdatedDelivered(
            newInventoryQuantity,
            deliveryItem.item_details?.unit_levels,
          ),
        };
        const response = await postSubmitForm(url, payload);
        if (response.status === 1) {
          showNotification(response.message, "Success");
          updatedDeliveryDetails = selectedItem_Transactions.map((item) =>
            item._id === selectedRow._id
              ? {
                  ...item,
                  type: "Debit",
                  before_correction_quantity: item.quantity,
                  correction_quantity: correctionQuantityToBeAdded.map(
                    ({ unit, value }) => ({ unit, value: +value }),
                  ),
                  quantity: convertedQuantity.map(({ unit, value }) => ({
                    unit,
                    value: +value,
                  })),
                  batch_inventory: GetUpdatedDelivered(
                    newInventoryQuantity,
                    deliveryItem.item_details?.unit_levels,
                  ),
                }
              : item,
          );
          setSelectedItem_Transactions(updatedDeliveryDetails);
          setEditModal(false);
          return true;
        } else {
          showNotification(response.message, "error");
          return false;
        }
      }
      // CASE 2: Updated quantity is smaller than used quantity
      else if (updated_Qty < used_Qty) {
        // console.log("Updated quantity is smaller than used quantity", 2);
        remainingQuantity = Number(used_Qty) - Number(updated_Qty);

        const newInventoryQuantity = [
          { unit: lastUnitObj, value: remainingQuantity + batch_Inv },
        ];
        const convertedQuantity = GetUpdatedDelivered(
          quantity,
          deliveryItem.item_details?.unit_levels,
        );

        const correctionQuantity = [
          { unit: lastUnitObj, value: Number(remainingQuantity) },
        ];
        const correctionQuantityToBeAdded = GetUpdatedDelivered(
          correctionQuantity,
          deliveryItem.item_details?.unit_levels,
        );

        let payload = {
          item_id: deliveryItem.item_details._id,
          store_id: selectedStore,
          batch: selectedItem.batch,
          batch_id: selectedItem._id,
          before_correction_quantity: selectedItem.quantity,
          quantity: convertedQuantity.map(({ unit, value }) => ({
            unit,
            value: +value,
          })),
          type: "Credit",
          correction_quantity: correctionQuantityToBeAdded.map(
            ({ unit, value }) => ({ unit, value: +value }),
          ),
          batch_inventory: GetUpdatedDelivered(
            newInventoryQuantity,
            deliveryItem.item_details?.unit_levels,
          ),
        };
        const response = await postSubmitForm(url, payload);
        if (response.status === 1) {
          showNotification(response.message, "Success");
          updatedDeliveryDetails = selectedItem_Transactions.map((item) =>
            item._id === selectedRow._id
              ? {
                  ...item,
                  type: "Credit",
                  before_correction_quantity: selectedItem.quantity,
                  correction_quantity: correctionQuantityToBeAdded.map(
                    ({ unit, value }) => ({ unit, value: +value }),
                  ),
                  quantity: convertedQuantity.map(({ unit, value }) => ({
                    unit,
                    value: +value,
                  })),
                  batch_inventory: GetUpdatedDelivered(
                    newInventoryQuantity,
                    deliveryItem.item_details?.unit_levels,
                  ),
                }
              : item,
          );
          setSelectedItem_Transactions(updatedDeliveryDetails);
          setEditModal(false);
          return true;
        } else {
          showNotification(response.message, "error");
          return false;
        }
      }
    } catch (error) {
      console.error("Error updating inventory:", error);
      showNotification("Error updating inventory", "Error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Corrections")}
            alternateTitle={props.t("Item Withdrawal Correction")}
            breadcrumbItem1={props.t("Withdrawal")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={() => loadMappedItems()}>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="store"
                          label={props.t("Store/Branch")}
                          type="select"
                          value={selectedStore}
                          onChange={(e) => {
                            setSelectedStore(e.target.value);
                          }}
                          errorMessage={props.t("Store/Branch is required.")}
                          validate={{
                            required: { value: true },
                          }}
                        >
                          <option value="">
                            {props.t("---Select Store/Branch---")}
                          </option>
                          {allstores &&
                            allstores.map((store) => {
                              return (
                                <option value={store._id}>{store.name}</option>
                              );
                            })}
                        </AvField>
                      </Col>
                      <Col lg={3}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("All Items")}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="_id"
                      data={allItems && allItems}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            filter={filterFactory()}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="xl"
                    style={{
                      width: "1000px",
                      maxWidth: "1010px",
                    }}
                    isOpen={transactionsModal}
                    toggle={() => setTransactionsModal(!transactionsModal)}
                  >
                    <ModalHeader
                      toggle={() => setTransactionsModal(!transactionsModal)}
                    >
                      Item Name: {selectedItem && selectedItem.name}
                    </ModalHeader>
                    <ModalBody>
                      {selectedItem_Transactions && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedItem_Transactions &&
                                          selectedItem_Transactions
                                        }
                                        columns={columns_transaction}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              pagination={paginationFactory(
                                                pagination_options,
                                              )}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
              <BatchWithdrawlCorrection
                isOpen={editModal}
                toggle={() => setEditModal(false)}
                onSubmit={handleSubmit}
                item={selectedRow}
                isLoading={isLoading}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemWithdrawlCorrection)),
);
